import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslocoModule } from "@jsverse/transloco";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import {
  DxDateBoxModule,
  DxFormModule,
  DxTagBoxModule,
  DxTextAreaModule
} from "devextreme-angular";
import { map } from "rxjs/operators";
import { SoapTemplateBackend } from "src/app/backend/api/soap-template.backend";
import { ButtonModule } from "src/app/components/ui/button/button.module";
import { ContainerModule } from "src/app/components/ui/container/container-module";
import { PageModule } from "src/app/components/ui/page/page.module";
import { RouterData } from "src/app/components/ui/router/router-data";
import { ReportModule } from "src/app/modules/bootstrap/modules/report/report.module";
import { absoluteUrl } from "src/app/support/navigation";
import { nextRuntimeId } from "src/app/support/runtime-id";
import { sntTranslate } from "src/app/support/translate";
import { SoapTemplateEditorComponent } from "./soap-template-editor/soap-template-editor.component";
import { SoapTemplateMaster } from "./soap-template-master/soap-template-master.component";
import { SoapTemplateDiagnosisComponent } from "src/app/modules/bootstrap/pms-ui/modules/organization/soap-template/soap-template-editor/soap-template-diagnosis/soap-template-diagnosis.component";
import { SoapTemplateAttachmentsComponent } from "src/app/modules/bootstrap/pms-ui/modules/organization/soap-template/soap-template-editor/soap-template-attachments/soap-template-attachments.component";
import { AttachmentsModule } from "src/app/components/ui/attachments/attachments.module";
import { TagListModule } from "src/app/components/ui/tag-list/tag-list.module";
import { SoapTemplateOrgansComponent } from "src/app/modules/bootstrap/pms-ui/modules/organization/soap-template/soap-template-editor/soap-template-organs/soap-template-organs.component";
import { SoapTemplateClinicalTagsComponent } from "src/app/modules/bootstrap/pms-ui/modules/organization/soap-template/soap-template-editor/soap-template-clinical-tags/soap-template-clinical-tags.component";
import { SoapTemplateAuthorsComponent } from "src/app/modules/bootstrap/pms-ui/modules/organization/soap-template/soap-template-editor/soap-template-authors/soap-template-authors.component";
import { PipesModule } from "src/app/pipes/pipes.module";
import { TableModule } from "src/app/components/ui/table/table.module";
import { DirectivesModule } from "src/app/modules/bootstrap/directives/directives.module";
import { EditableModule } from "src/app/components/ui/editable/editable.module";
import { lastValueFrom } from "rxjs";
import { CreateTagFunctionModule } from "src/app/modules/bootstrap/pms-ui/functions/tag/create-tag/create-tag-function.module";

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,

    PageModule,
    ReportModule,
    ContainerModule,
    ButtonModule,
    AttachmentsModule,
    TagListModule,
    DxFormModule,
    DxTextAreaModule,
    DxTagBoxModule,
    DxDateBoxModule,
    PipesModule,
    TableModule,
    DirectivesModule,
    CreateTagFunctionModule,

    RouterModule.forChild([
      {
        path: "",
        children: [
          {
            path: "",
            component: SoapTemplateMaster
          },
          {
            path: ":id",
            component: SoapTemplateEditorComponent,
            data: <RouterData>{
              tab: {
                id: nextRuntimeId(),
                icon: async () => "fa-light fa-file-pen",
                name: async (context) =>
                  lastValueFrom(
                    context.injector
                      .get(SoapTemplateBackend)
                      .load(context.params["id"])
                      .pipe(map((soapTemplate) => soapTemplate.name))
                  )
              },
              breadcrumb: {
                id: nextRuntimeId(),
                icon: async () => `fa-light fa-file-pen`,
                url: async () => absoluteUrl("/organization/soap-templates"),
                label: async (context) =>
                  lastValueFrom(
                    context.injector
                      .get(SoapTemplateBackend)
                      .load(context.params["id"])
                      .pipe(map((soapTemplate) => soapTemplate.name))
                  )
              }
            }
          }
        ],
        data: <RouterData>{
          tab: {
            id: nextRuntimeId(),
            icon: async () => "fa-light fa-file-invoice",
            name: async () => sntTranslate(marker("Modello SOAP"))
          },
          breadcrumb: {
            id: nextRuntimeId(),
            icon: async () => `fa-light fa-file-invoice`,
            url: async () => absoluteUrl("/organization/soap-templates"),
            label: async () => sntTranslate(marker("Modello SOAP"))
          }
        }
      }
    ]),
    EditableModule
  ],
  declarations: [
    SoapTemplateMaster,
    SoapTemplateEditorComponent,
    SoapTemplateDiagnosisComponent,
    SoapTemplateOrgansComponent,
    SoapTemplateClinicalTagsComponent,
    SoapTemplateAttachmentsComponent,
    SoapTemplateAuthorsComponent
  ],
  exports: [
    SoapTemplateEditorComponent,
    SoapTemplateDiagnosisComponent,
    SoapTemplateOrgansComponent,
    SoapTemplateClinicalTagsComponent,
    SoapTemplateAttachmentsComponent,
    SoapTemplateAuthorsComponent
  ]
})
export class SoapTemplateModule {}
